<template>
  <div class="home">
    <p style="
        text-align: center;
        padding: 40px 0px 10px 0px;
        margin: 0 0 30px;
      ">
      <img src="https://pra.pspp-integrated.com/assets/img/logo.png" width="130" />
    </p>

    <div class="profile-bar">
      <div class="profile" @click="to('/profil')">
        <div>
          <p style="margin-left: 5px">
            <b style="display: flex; align-items: center;gap:5px; text-transform: capitalize;">
              {{ user.nama }}
              <img height="24" v-if="false"
                src="data:image/png;base64,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"
                alt="guarantee">
            </b>
            <b style="font-weight: 500;font-size: 14px;">{{ user.no_daftar }}{{ user.prefix_daftar }}</b>
          </p>
        </div>
      </div>
      <div class="logout" @click="logout()">
        <img src="https://img.icons8.com/?size=48&id=Q1xkcFuVON39&format=png" height="24" />
      </div>
    </div>

    <div class="jadwal">
      <div class="jadwal-body">
        <div @click="to('/jadwal')">
          <div>
            <h3>JADWAL KBM</h3>
          </div>
          <div style="margin-left: 4px" class="jadwal-scan">
            <div v-if="jadwal.length > 0" class="jadwal-exist">
              <b> {{ jadwal[0].hari_mengajar }}, {{ jadwal[0].tgl_mengajar }} </b>
              <ul>
                <li v-for="(item, index) in jadwal[0].jadwal" :key="index">
                  <p>
                    {{ item.waktu_mulai }} - {{ item.waktu_selesai }} ({{
                      item.jumlah_sesi
                    }}
                    sesi)
                  </p>
                  <p>{{ item.mata_diklat }}</p>
                </li>
              </ul>
            </div>
            <div v-else class="jadwal-empty">
              <div>
                <p>Belum ada jadwal KBM</p>
              </div>
            </div>
          </div>
        </div>
        <div class="scan" @click="scan()">
          <div>
            <img src="./../assets/icons/scan.png" height="24" />
            Kehadiran
          </div>
        </div>
      </div>
      <div class="absensi" v-if="absen && absen.id">
        <div>
          <p>Jam Masuk</p>
          <h3>{{ moment(absen.clock_in).format('HH:mm') }}</h3>
        </div>
        <div>
          <p>Jam Pulang</p>
          <h3>{{ absen.clock_out ? moment(absen.clock_out).format('HH:mm') : '-' }}</h3>
        </div>
      </div>
    </div>

    <div class="body">
      <div class="main-menu">
        <div @click="to('/pemberkasan')">
          <p>
            <img src="./../assets/icons/file-storage.svg" />
          </p>
          <span> Pemberkasan</span>
        </div>

        <div @click="to('/soal')">
          <p>
            <img src="./../assets/icons/book.svg" />
          </p>
          <span> Soal-soal</span>
        </div>
        <div @click="to('/ujian')">
          <p>
            <img src="./../assets/icons/test.svg" />
          </p>
          <span> Ujian Online </span>
        </div>
        <div @click="to('/hasil-ujian')">
          <p>
            <img src="./../assets/icons/medal.svg" />
          </p>
          <span> Nilai Ujian </span>
        </div>
        <div @click="to('/kelas-prioritas')">
          <p>
            <img src="./../assets/icons/prioritas.png" />
          </p>
          <span> Kelas Prioritas</span>
        </div>
        <div @click="to('/praktek-terbang')">
          <p>
            <img src="./../assets/icons/travelling.svg" />
          </p>
          <span> International Study Tour</span>
        </div>
        <div @click="to('/sertifikat')">
          <p>
            <img src="./../assets/icons/certificate.svg" />
          </p>
          <span> Sertifikat</span>
        </div>
        <div @click="to('/wisuda')" v-if="false">
          <p>
            <img src="./../assets/icons/graduated.png" />
          </p>
          <span> Daftar Wisuda</span>
        </div>
        <div @click="to('/pembayaran')">
          <p>
            <img src="./../assets/icons/pembayaran.png" />
          </p>
          <span> Pembayaran</span>
        </div>
        <div @click="to('/kidora')">
          <p style="padding:0;margin:4px 0;">
            <img src="./../assets/icons/kidora.png" style="height:70px;" />
          </p>
          <span> Kidora</span>
        </div>
        <div @click="to('/marketing')" v-if="false">
          <p style="padding:0;margin:20px 0 4px;">
            <img src="./../assets/icons/siswa.png" style="height:40px;" />
          </p>
          <span> Siswa Get Siswa</span>
        </div>
        <div @click="to('/refund')" v-if="false">
          <p style="padding:0;margin:20px 0 4px;">
            <img src="./../assets/icons/cashback.png" style="height:40px;" />
          </p>
          <span> Refund Tablet</span>
        </div>
        <div @click="to('/angket')" v-if="false">
          <p style="padding:0;margin:20px 0 4px;">
            <img src="./../assets/icons/rating.png" style="height:40px;" />
          </p>
          <span> Angket Penilaian</span>
        </div>
        <div @click="to('/tiket')" v-if="false">
          <p>
            <img src="./../assets/icons/airplane-ticket.svg" />
          </p>
          <span> Tiket Pesawat</span>
        </div>
        <div @click="to('/paket-wisata')" v-if="false">
          <p>
            <img src="./../assets/icons/wisata.png" />
          </p>
          <span> Paket Wisata</span>
        </div>
      </div>
    </div>

    <div class="modal" @click="closeModalIklan" v-if="modalIklanOpen">
      <div class="modal-iklan">
        <a href="https://s.id/psppmoment" target="_blank">
          <img src="./../assets/iklan.jpeg" width="300px">
        </a>
      </div>
    </div>

    <span class="versi">Versi 1.1.0</span>
  </div>
</template>

<script>
import Plane from "./icons/Plane.vue";
import Calendar from "./icons/Calendar.vue";
import User from "./icons/User.vue";
import People from "./icons/People.vue";

import moment from "moment";
import * as psppApi from "./../api/Api";

export default {
  name: "Home",
  components: {
    User,
    Plane,
    Calendar,
    People,
  },
  data() {
    let sudahLihatIklan = true;

    if (localStorage.getItem('sudah-lihat-iklan')) {
      const iklanTerakhir = localStorage.getItem('sudah-lihat-iklan');
      if (moment().format('YYYY-MM-DD') != iklanTerakhir) {
        sudahLihatIklan = false;
      } else {
        sudahLihatIklan = true;
      }
    } else {
      sudahLihatIklan = false;
    }
    return {
      modalIklanOpen: false,//!sudahLihatIklan,
      user: {},

      jadwal: [],
      absen: {}
    };
  },
  methods: {
    moment,
    closeModalIklan(e) {
      if (e.target.classList[0] == 'modal') {
        this.modalIklanOpen = false;
        localStorage.setItem('sudah-lihat-iklan', moment().format('YYYY-MM-DD'))
      }
    },
    logout() {
      localStorage.clear();
      location.reload();
    },
    to(to) {
      setTimeout(() => {
        this.$router.push(to);
      }, 150);
    },
    scan() {
      this.$router.push('/scan')
    }
  },
  mounted() {
    if (!this.$store.state.settings.user.id) {
      this.$router.push("/login");
    }

    this.user = this.$store.state.settings.user;

    // api.get("/v1/SoapController/airportList").then((r) => {
    //   this.$store.commit("flights/setAirportList", r);
    // });

    // api.get("/v1/SoapController/airlineList").then((r) => {
    //   this.$store.commit("flights/setAirlineList", r);
    // });

    psppApi
      .get("/v1/siswa/JadwalController/getToday?id_siswa=" + this.user.id)
      .then((r) => {
        this.jadwal = r.jadwal;
        this.absen = r.absen;
      });
  },
};
</script>

<style scoped lang="scss">
.home {
  background: #fff;
  position: relative;
  height: 100vh;

  .navbar {
    color: #333;
    padding: 18px 15px;
    font-weight: 600;
    font-size: 18px;
  }

  .profile-bar {
    display: flex;
    justify-content: space-between;
    padding: 10px 30px;
  }

  .profile {
    display: grid;
    grid-template-columns: 1fr;

    p {
      margin: 0;
    }

    &:active {
      opacity: 0.5;
    }
  }

  .jadwal {
    p.logo {
      text-align: center;
    }

    .jadwal-body {
      display: grid;
      grid-template-columns: 1fr 100px;
      gap: 5px;

      h3 {
        margin: 4px;
        font-size: 16px;
      }

      .scan {
        display: grid;
        place-items: center;
        background: #fff;
        border-radius: 7px;
        color: #333;
        font-size: 14px;
        height: 80px;

        >div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 6px;

          img {
            display: block;
            width: 24px;
            margin-bottom: 5px;
          }
        }
      }
    }

    .absensi {
      border-top: 1px solid #fff;
      margin-top: 15px;
      padding-top: 10px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);

      p,
      h3 {
        margin: 0;
        text-align: center;
      }

      p {
        margin-bottom: 5px;
      }
    }

    margin: 15px 30px;
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0px 1px 3px #aaa;
    background: var(--primary);
    color: #fff;

    &:active {
      background: #2c9cff;
    }

    .icon {
      width: 30px;
    }

    ul {
      padding-left: 20px;
      margin: 0;
      margin-top: 15px;

      li {
        margin-bottom: 15px;

        p {
          margin: 0;

          &:first-child {
            font-weight: 500;
          }
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .body {
    background: #fff;
    padding: 15px 0px;
  }

  .main-menu {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 15px;
    margin: 0px 15px;

    div,
    a {
      background: #fff;
      color: #333;
      text-align: center;
      text-decoration: none;
      font-size: 14px;
      cursor: pointer;

      &:active {
        opacity: 0.5;
      }

      p {
        padding: 10px;
        text-align: center;
      }

      img {
        height: 30px;
      }
    }
  }

  .versi {
    display: block;
    font-size: 12px;
    margin-top: 60px;
    margin-left: 30px;
    padding-bottom: 15px;
  }
}
</style>
